<span>
    <mat-form-field
        [ngClass]="errorStateMatcher?.validationClass ?? 'valid'"
        [appearance]="appearance ?? 'fill'"
    >
        <mat-label appRemoveAriaOwns>{{ property.displayKey ? 'Select ' + property.Key : '' }}</mat-label>
        <span
            *ngIf="icon"
            matPrefix
            ><i class="{{ icon }}"></i
        ></span>
        <input
            matInput
            [matDatepicker]="datePicker"
            [value]="property.Value"
            [matDatepickerFilter]="property.dateFilter"
            (dateChange)="dateChanged($event); errorStateMatcher?.markAsInteracted()"
            (blur)="errorStateMatcher?.markAsInteracted()"
            [disabled]="disabled ? disabled : null"
            [readonly]="true"
            (click)="datePicker.open()"
            [errorStateMatcher]="errorStateMatcher"
        />
        <mat-datepicker-toggle
            matSuffix
            [for]="datePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker
            #datePicker
            startView="{{ startView }}"
            (yearSelected)="chosenYearHandler($event, datePicker)"
            (monthSelected)="chosenMonthHandler($event, datePicker)"
            [disabled]="disabled ? disabled : null"
            (closed)="closed()"
        >
        </mat-datepicker>
        <mat-hint>{{ property.hint }}</mat-hint>
        <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
    </mat-form-field>
    <ng-container *ngIf="property?.quickSelectFilter && property?.showQuickSelectFilter">
        <button
            attr.data-cy="filter-input-custom-button-{{ property.Key }}"
            (click)="property?.quickSelectFilter.filterRef.open(); $event.stopPropagation()"
            class="button is-small is-primary add-custom-quick-select"
        >
            <span class="margin-right-half-em text-custom">
                {{ property.quickSelectFilterName || 'Quick Select' }}
            </span>
            <i class="fas fa-fw fa-caret-down"></i>
        </button>
        <app-filter-input
            attr.data-cy="filter-input-select-option-{{ property.Key }}"
            [property]="property.quickSelectFilter"
            class="filter-input-custom"
        >
        </app-filter-input>
    </ng-container>
</span>
